
<script setup>

  import { ref, computed, onBeforeUnmount } from 'vue';

  const props = defineProps( { duration: Number, path: String } );

  const emit = defineEmits( [ 'next' ] );

  let frame = null;

  let start = null;

  let unlocked = true;

  const opacity = ref( 0 );

  const scale = ref( 1 );

  const twenty = computed( () => props.duration * 0.2 );

  const sixty = computed( () => props.duration * 0.6 );

  function step( now ) {

    if ( ! start ) start = now;

    const delta = now - start;

    if ( delta > sixty.value && unlocked ) {
      
      emit( 'next' );

      unlocked = false;

    }

    opacity.value =
    
      delta < twenty.value ? delta / twenty.value :
      
      delta > sixty.value ? 1 - ( delta - sixty.value ) / twenty.value : 1;

    scale.value = delta / props.duration * 0.25 + 1;

    if ( delta < props.duration ) frame = requestAnimationFrame( step );

  }

  function animate() {

    cancelAnimationFrame( frame );

    start = null;

    unlocked = true;

    step( performance.now() );

  }

  onBeforeUnmount( () => cancelAnimationFrame( frame ) );

  defineExpose( { animate } );
  
</script>

<template>

  <div class="relative overflow-hidden" :style="{ opacity }">

    <div class="w-full h-full bg-fixed bg-cover bg-center"
    
      :style="{
        
        transform: `scale( ${ scale } )`,
      
        'background-image': `radial-gradient( rgba( 24, 22, 21, 0.75 ) 40%, rgba( 24, 22, 21, 1 ) ), url( ${ path } )`
        
      }" />

  </div>

</template>
